import { applyMiddleware, combineReducers, legacy_createStore } from "redux";
import { thunk } from "redux-thunk";
import { authReducer } from "../User/State/Auth/Reducer";
import { productReducer } from "../User/State/Product/Reducer";
import { cartReducer } from "../User/State/Cart/Reducer";
import { colorReducer } from "../Admin/State/Color/Reducer";
import { brandReducer } from "../Admin/State/Brand/Reducer";
import { sizeReducer } from "../Admin/State/Size/Reducer";
import { vendorProductReducer } from "../Vendor/State/Product/Reducer";
import { vendorProductVariantReducer } from "../Vendor/State/ProductVariant/Reducer";
import { vendorProductPriceHistoryReducer } from "../Vendor/State/ProductPriceHistory/Reducer";
import { vendorProductImageReducer } from "../Vendor/State/ProductImage/Reducer";
import { vendorProductAttributeReducer } from "../Vendor/State/ProductAttribute/Reducer";
import adminOrderReducer from "../Admin/State/Order/Reducer";
import adminVendorReducer from "../Admin/State/Vendor/Reducer";
import adminUserReducer from "../Admin/State/User/Reducer";
import adminProductReducer from "../Admin/State/Product/Reducer";
import { adminCategoryReducer } from "../Admin/State/Category/Reducer";
import { orderReducer } from "../User/State/Order/Reducer";
import { publicBrandReducer } from "../User/State/Brand/Reducer";
import { publicColorReducer } from "../User/State/Color/Reducer";
import { publicSizeReducer } from "../User/State/Size/Reducer";
import { publicCategoryReducer } from "../User/State/Category/Reducer";
import { addressReducer } from "../User/State/Address/Reducer";
import { reviewReducer } from "../User/State/Review/Reducer";
import { adminSubCategoryReducer } from "../Admin/State/SubCategory/Reducer";
import { adminProductCategoryReducer } from "../Admin/State/ProductCategory/Reducer";
import { adminBannerReducer } from "../Admin/State/Banner/Reducer";
import { publicBannerReducer } from "../User/State/Banner/Reducer";
import { wishlistReducer } from "../User/State/Wishlist/Reducer";
import { employeeReducer } from "../Admin/State/Employee/Reducer";
import { pinCodeReducer } from "../Admin/State/PinCodeArea/Reducer";
import employeeOrderReducer from "../Employee/State/Order/Reducer";
import { vendorProductOfferReducer } from "../Vendor/State/Offer/Reducer";
import adminOfferReducer from "../Admin/State/Offer/Reducer";
import { paymentReducer } from "../User/State/Payment/Reducer";
import { adminPaymentReducer } from "../Admin/State/Payment/Reducer";
import vendorPaymentReducer from "../Vendor/State/Payment/Reducer";
import vendorOrderReducer from "../Vendor/State/Order/Reducer";
import VendorReducer from "../Vendor/State/Vendor/Reducer";
import { uiColorFontReducer } from "../Admin/State/UIColorFont/Reducer";
import { publicUIColorFontsReducer } from "../User/State/UIElement/Reducer";
import { couponReducer } from "../Admin/State/Coupon/Reducer";
import { vendorProductColorReducer } from "../Vendor/State/ProductColor/Reducer";
import adminProfileReducer from "../Admin/State/Profile/Reducer";
import employeeProfileReducer from "../Employee/State/Employee/Reducer";
import { adminDesignerDiscountBannerReducer } from "../Admin/State/DesignerDiscountBanner/Reducer";
import { publicDesignerDiscountBannerReducer } from "../User/State/DesignerDiscountBanner/Reducer";
import { publicCurrencyReducer } from "../User/State/Currency/Reducer";
import { shippingChargeReducer } from "../Admin/State/ShippingCharge/Reducer";


const rootReducers = combineReducers({
    auth: authReducer,
    products: productReducer,
    brand: publicBrandReducer,
    color: publicColorReducer,
    size: publicSizeReducer,
    publicCategory: publicCategoryReducer,
    publicBanners: publicBannerReducer,
    publicDesignerDiscountBanner: publicDesignerDiscountBannerReducer,
    reviews: reviewReducer,
    cart: cartReducer,
    wishlist: wishlistReducer,
    payment: paymentReducer,
    address: addressReducer,
    order: orderReducer,
    colors: colorReducer,
    brands: brandReducer,
    sizes: sizeReducer,
    payments: adminPaymentReducer,
    banners: adminBannerReducer,
    adminProfile: adminProfileReducer,
    adminOffers: adminOfferReducer,
    adminOrder: adminOrderReducer,
    adminVendor: adminVendorReducer,
    adminUser: adminUserReducer,
    adminCategories: adminCategoryReducer,
    adminSubCategories: adminSubCategoryReducer,
    adminProductCategories: adminProductCategoryReducer,
    employees: employeeReducer,
    pincodeAreas: pinCodeReducer,
    adminProduct: adminProductReducer,
    vendorProducts: vendorProductReducer,
    variants: vendorProductVariantReducer,
    price: vendorProductPriceHistoryReducer,
    vendorProductColor: vendorProductColorReducer,
    image: vendorProductImageReducer,
    offer: vendorProductOfferReducer,
    vendorOrder: vendorOrderReducer,
    attribute: vendorProductAttributeReducer,
    employeeOrders: employeeOrderReducer,
    vendorPayments: vendorPaymentReducer,
    vendorProfile: VendorReducer,
    employeeProfile: employeeProfileReducer,
    adminUIColorFonts: uiColorFontReducer,
    publicUIColorFonts: publicUIColorFontsReducer,
    coupons: couponReducer,
    designerDiscountBanners: adminDesignerDiscountBannerReducer,
    publicCurrencies: publicCurrencyReducer,
    shippingCharges: shippingChargeReducer,
})
export const store = legacy_createStore(rootReducers, applyMiddleware(thunk))